import classNames from "classnames"
import { TextareaHTMLAttributes } from "react"
import { inputClassNames } from "./Input"

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value?: string
  setValue?: (v: string) => void
}

export const textareaClassNames = classNames(inputClassNames)

export function Textarea({ children, className, value, setValue, ...html }: TextareaProps) {
  const handleChange = (v: string) => {
    if (setValue) setValue(v)
  }

  return <textarea
    className={classNames(textareaClassNames, "w-full resize-none h-10", className)}
    value={value}
    onChange={v => handleChange(v.currentTarget.value)}
    {...html}>
    {children}
  </textarea>
}
